import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_save_configuration_by_environment_warehouseService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { application_name: string, environment: string, warehouseId: number, Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Auth_Authorization?: string, Auth_TokenUrl?: string, Auth_Scope?: string, Auth_GrantType?: string, Auth_ClientId?: string, Auth_ClientSecret?: string, Auth_Username?: string, Auth_Password?: string, Service_PickRequest?: string }): Promise<{ Endpoint?: string, Port?: string, Username?: string, Password?: string, ApiKey?: string, ApiSecret?: string, debugDetails?: string[], Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Service_PickRequest?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.application_name)) {
      $missingRequiredInParams.push('\'application_name\'');
    }
    if (isNil($inParams.environment)) {
      $missingRequiredInParams.push('\'environment\'');
    }
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

